import { render, staticRenderFns } from "./unassignedlistdesktop.vue?vue&type=template&id=825faccc&"
import script from "./unassignedlistdesktop.vue?vue&type=script&lang=js&"
export * from "./unassignedlistdesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports